import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=186d3b88&scoped=true&"
import script from "./ErrorView.vue?vue&type=script&lang=ts&"
export * from "./ErrorView.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./ErrorView.vue?vue&type=style&index=0&id=186d3b88&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "186d3b88",
  null
  ,true
)

component.options.__file = "ErrorView.vue"
export default component.exports